import React from 'react';
import {
  VictoryGroup,
  VictoryArea,
  VictoryBar,
  VictoryLabel,
  VictoryAxis,
  VictoryChart,
} from 'victory';
import { CircularProgressbarWithChildren } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { Tooltip } from '@material-ui/core';
import { abbrNum } from './mask';
import { getDashFiltered } from './utils';
import { makeStyles } from '@material-ui/core/styles';
import downArrow from '../images/downArrow.png';
import { Bar } from 'react-chartjs-2';

export const GeneralGraphBar = ({ el }) => {
  let filteredDash = getDashFiltered(el);
  return (
    <div className={`info-box margin-left`}>
      <h4>{el.label}</h4>
      <VictoryChart
        domainPadding={20}
        padding={{ top: 100, bottom: 0, left: 20, right: 50 }}
      >
        {filteredDash.map((val, i) => {
          if (i < 3) {
            return (
              <VictoryAxis
                dependentAxis
                key={i}
                tickValues={[0]}
                style={{
                  axis: { stroke: 'none' },
                  tickLabels: { fontSize: 20 },
                }}
                tickFormat={(t) => val.label}
                axisValue={i + 1}
                tickLabelComponent={
                  <VictoryLabel textAnchor="start" dy={-50} />
                }
              />
            );
          }
          return null;
        })}

        <VictoryBar
          horizontal
          sortOrder="descending"
          style={{ data: { fill: '#25D0F4', width: 35 } }}
          data={filteredDash.map((tp, index) => {
            if (index < 3) {
              return {
                x: tp.label,
                y: tp.valor,
                label: abbrNum(tp.valor, 1),
              };
            }
            return null;
          })}
          labelComponent={
            <VictoryLabel
              inline
              textAnchor="start"
              style={[{ fill: 'black', fontSize: 20, fontWeight: 'bold' }]}
            />
          }
        />
      </VictoryChart>
    </div>
  );
};

export const CustomGraphBar = ({
  el,
  dashTitle,
  tooltipTitle,
  enableTooltip,
}) => {
  const useStylesBootstrap = makeStyles(() => ({
    arrow: {
      color: '#000000',
    },
    tooltip: {
      backgroundColor: '#FFFFFF',
      minWidth: '181px',
      minHeight: '464px',
      border: '1px solid black',
    },
  }));

  const classesTooltip = useStylesBootstrap();

  let filteredDash = getDashFiltered(el);

  return (
    <div className={`info-box margin-left`}>
      <h4>{dashTitle}</h4>
      <VictoryChart
        domainPadding={20}
        padding={{ top: 100, bottom: 0, left: 20, right: 50 }}
        horizontal
      >
        {filteredDash.map((val, i) => {
          if (i < 3) {
            return (
              <VictoryAxis
                dependentAxis
                key={i}
                tickValues={[0]}
                style={{
                  axis: { stroke: 'none' },
                  tickLabels: { fontSize: 20 },
                }}
                tickFormat={(t) => val.label}
                axisValue={i + 1}
                tickLabelComponent={
                  <VictoryLabel textAnchor="start" dy={-50} />
                }
              />
            );
          }
          return null;
        })}

        <VictoryBar
          horizontal
          sortOrder="descending"
          style={{ data: { fill: '#25D0F4', width: 35 } }}
          data={filteredDash.map((tp, index) => {
            if (index < 3) {
              return {
                x: tp.label,
                y: tp.valor,
                label: abbrNum(tp.valor, 1),
              };
            }
            return null;
          })}
          labelComponent={
            <VictoryLabel
              inline
              textAnchor="start"
              style={[{ fill: 'black', fontSize: 20, fontWeight: 'bold' }]}
            />
          }
        />
      </VictoryChart>
      {enableTooltip && (
        <Tooltip
          classes={classesTooltip}
          placement="left"
          leaveDelay={0}
          interactive
          arrow
          title={
            <React.Fragment>
              <div className={`dashboard-tooltip-container margin-left`}>
                <h4 className="dashboard-tooltip-title">{tooltipTitle}</h4>
                <VictoryChart
                  height={700}
                  domainPadding={20}
                  padding={{ top: 100, bottom: 0, left: 20, right: 50 }}
                >
                  {el.itens
                    .sort((a, b) => a.valor - b.valor)
                    .map((val, i) => {
                      return (
                        <VictoryAxis
                          dependentAxis
                          key={i}
                          tickValues={[0]}
                          style={{
                            axis: { stroke: 'none' },
                            tickLabels: { fontSize: 20 },
                          }}
                          tickFormat={(t) => val.label}
                          axisValue={i + 1}
                          tickLabelComponent={
                            <VictoryLabel textAnchor="start" dy={-50} />
                          }
                        />
                      );
                    })}

                  <VictoryBar
                    horizontal
                    sortOrder="descending"
                    style={{ data: { fill: '#25D0F4', width: 35 } }}
                    data={el.itens
                      .sort((a, b) => a.valor - b.valor)
                      .map((tp, index) => {
                        return {
                          x: tp.label,
                          y: tp.valor,
                          label: abbrNum(tp.valor, 1),
                        };
                      })}
                    labelComponent={
                      <VictoryLabel
                        inline
                        textAnchor="start"
                        style={[
                          { fill: 'black', fontSize: 20, fontWeight: 'bold' },
                        ]}
                      />
                    }
                  />
                </VictoryChart>
              </div>
            </React.Fragment>
          }
        >
          <img className="popArrow" src={downArrow} alt="" />
        </Tooltip>
      )}
    </div>
  );
};

export const CircularGraph = ({ el }) => {
  // console.log(el);
  return (
    <div className={`info-box margin-left`}>
      <h4>{el.label}</h4>
      <div className="padding-box">
        <CircularProgressbarWithChildren
          styles={{
            path: {
              stroke: `#25D0F4`,
              strokeLinecap: 'butt',
            },
            trail: {
              stroke: '#d8d8d8',
              strokeLinecap: 'butt',
              transform: 'rotate(0.25turn)',
              transformOrigin: 'center center',
            },
          }}
          value={el.scoreMedio}
        >
          <h2>{Math.ceil(el.scoreMedio)}</h2>
          <div style={{ fontSize: 10, marginTop: 5, color: '#d8d8d8' }}>
            de 100%
          </div>
        </CircularProgressbarWithChildren>
      </div>
    </div>
  );
};

export const VictoryGraph = ({ el, min, max }) => {
  let filteredDash = [];
  let filteredTick = [];
  if (el.label === 'APF') {
    filteredDash = getDashFiltered(el);
    filteredTick = filteredDash.map((el) => el.label);
    console.log(filteredTick);
  }
  const useStylesBootstrap = makeStyles(() => ({
    arrow: {
      color: '#000000',
    },
    tooltip: {
      backgroundColor: '#FFFFFF',
      minWidth: '181px',
      minHeight: '464px',
      border: '1px solid black',
    },
  }));

  const classesTooltip = useStylesBootstrap();
  return (
    <div className={`info-box margin-left`}>
      {/* {console.log(el)} */}
      <h4>{el.label}</h4>
      <h5>{el?.descricao}</h5>
      <label style={{ fontSize: 12, fontWeight: 300 }}>
        <strong style={{ fontSize: 15, fontWeight: 600 }}>{el.valor}</strong>
        <br></br>
        {el.subLabel}
      </label>
      <VictoryGroup
        padding={{ top: 20, bottom: 0, right: 0 }}
        style={{
          parent: { marginTop: 42 },
        }}
      >
        <VictoryArea
          domain={{
            y: [min, max],
          }}
          style={{
            data: {
              stroke: '#25D0F4',
              strokeWidth: 5,
              strokeLinecap: 'round',
              fill: '#F3FBFE',
            },
          }}
          data={el.historico
            .sort((a, b) => a.data.localeCompare(b.data))
            .map((hs, index) => {
              return {
                x: index + 1,
                y: hs.valor,
              };
            })}
        />
      </VictoryGroup>
      {el.label === 'APF' && (
        <Tooltip
          classes={classesTooltip}
          placement="left"
          leaveDelay={0}
          interactive
          arrow
          title={
            <React.Fragment>
              <div className={`dashboard-tooltip-container margin-left`}>
                <h4 className="dashboard-tooltip-title">APF por tipo</h4>
                <VictoryChart
                  height={300}
                  domainPadding={10}
                  padding={{ top: 100, bottom: 0, left: 20, right: 50 }}
                >
                  <VictoryBar
                    horizontal
                    sortOrder="descending"
                    style={{ data: { fill: '#25D0F4', width: 35 } }}
                    data={filteredDash
                      .sort((a, b) => a.valor - b.valor)
                      .map((tp, index) => {
                        return {
                          x: tp.label,
                          y: tp.valor,
                          label: abbrNum(tp.valor, 1),
                        };
                      })}
                    labelComponent={
                      <VictoryLabel
                        inline
                        textAnchor="start"
                        style={[
                          { fill: 'black', fontSize: 20, fontWeight: 'bold' },
                        ]}
                      />
                    }
                  />
                  {filteredDash.map((el) => {
                    return (
                      <VictoryAxis
                        dependentAxis
                        label={el.label}
                        axisValue={el.label}
                        style={{
                          axis: { stroke: 'none' },
                          tickLabels: { display: 'none' },
                        }}
                        axisLabelComponent={
                          <VictoryLabel
                            style={{ textAlign: 'left', fontSize: 20 }}
                            textAnchor="start"
                            dy={-70}
                            x={20}
                          />
                        }
                      />
                    );
                  })}
                </VictoryChart>
              </div>
            </React.Fragment>
          }
        >
          <img className="popArrow" src={downArrow} alt="" />
        </Tooltip>
      )}
    </div>
  );
};

export const NewBarGraph = ({ labels, title, data }) => {
  const dataGraphBar = {
    labels: labels,
    datasets: [
      {
        label: 'Registros SAS',
        data: [data],
        backgroundColor: ['rgba(66, 165, 245, 0.8)'],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
  };

  return (
    <div className="chartArea">
      <div className="header">
        <h1 className="title">Registros SAS</h1>
      </div>
      <Bar data={dataGraphBar} options={options} />
    </div>
  );
};
